<template >
  <BDLayout v-if="isBDSelected">
    <div class="transaction">
      <section id="transaction-products">
        <div class="container">
           <!--<div style="display:flex;align-items:center;justify-content:space-between;">
            <h6 class="fw-bold text-primary" style="margin:0">Approvals</h6>
            <button class="btn btn-sm btn-outline-primary" @click="refreshApprovals" :disabled="loading">
              <span v-if="loading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp;Fetching Approvals...
              </span>
              <span v-else>Refresh</span>
            </button>
          </div>
         
            <button class="btn-style pull-right" style="margin-top: -50px;float:right;" @click="$router.push('/settings/approvals/pending')">Order Requests</button>
          -->
          <div class="warehouse-inventory-card-wrapper">
            <!--
              <div class="warehouse-inventory-card">
                <p>Pending PO Approvals</p>
                <strong class="blue">0</strong>
              </div>
            -->
            <div class="warehouse-inventory-card" @click="setActiveApproval('pending')" :style="{border: activeApproval === 'pending' ?  '1px solid #cccccc': ''}">
              <p style="font-size: 10px;" class="mt-4">Pending Approvals</p>
              <strong class="blue">{{ this.pendingApprovals.length }}</strong>
            </div>
            <div class="warehouse-inventory-card" @click="setActiveApproval('urgent')" :style="{border: activeApproval === 'urgent' ?  '1px solid #cccccc': ''}">
              <p>Urgent Approvals</p>
              <strong class="red">{{ urgentApprovals.length }}</strong>
            </div>
            <div class="warehouse-inventory-card"  @click="setActiveApproval('processed')" :style="{border: activeApproval === 'processed' ?  '1px solid #cccccc': ''}">
              <p>Processed Requests</p>
              <strong class="green">{{ this.processedApprovals.length}}</strong>
            </div>
          </div>

          <!-- Summary Statistics Cards -->
          <div class="warehouse-inventory-card-wrapper mt-3">
            <div class="warehouse-inventory-card">
              <p>Total Number</p>
              <strong class="primary">{{ totalApprovals }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Total PO Approvals</p>
              <strong class="info">{{ totalPOApprovals }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Total PR Approvals</p>
              <strong class="warning">{{ totalPRApprovals }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Duration > 2 Months</p>
              <strong class="danger">{{ durationGreaterThanTwoMonths }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Duration 1-2 Months</p>
              <strong class="secondary">{{ durationOneToTwoMonths }}</strong>
            </div>
          </div>
          <div>
           
            <SkeletonLoader v-if="showSkeleton" type="table" :rows="6" :columns="10" />
            <div v-else-if="activeApprovals?.length > 0" class="approvals-data-table-wrapper">
            <table
              :key="`approvals-${activeApproval}-${isBDSelected ? 'bd' : 'app'}-${tableKeyNonce}`"
              ref="approvalsTableBD"
              id="approvalsTableBD"
              class="table table-sm table-hover mb-0"
              @click="onApprovalsTableClick"
            >
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Date</th>
                  <th>Priority</th>
                  <th>Request</th>
                  <th>Order No.</th>
                  <th>Requester</th>
                  <th v-if="activeApproval == 'processed'">Actioned By</th>
                  <th v-if="activeApproval == 'processed'">Actioned Date</th>
                  <th v-if="activeApproval == 'processed'">Comment</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(approval, index) in activeApprovals" v-bind:key="approval.id" :data-approval-id="approval.id">
                  <td>{{ index+1 }}</td>
                  <td :data-order="approval.createdAt ? new Date(approval.createdAt).getTime() : 0">{{ formatDate(approval.createdAt,"true") }}</td>
                  <td>
                    <button v-if="approval.priority == 'urgent'" class="btn btn-sm btn-danger" style="border-radius: 15px;">Urgent</button>
                    <button v-else class="btn btn-sm btn-primary" style="border-radius: 15px;">Normal</button>
                  </td>
                  <td v-if="approval.module == 'purchase'">Purchase Order</td>
                  <td v-else-if="approval.module == 'pickup'">Pickup Note</td>
                  <td v-else-if="approval.module == 'dispatch'">Dispatch Note</td>
                  <td v-else-if="((approval.module || '').toString().toLowerCase() === 'businessopportunity') || ((approval.module || '').toString().toLowerCase() === 'bidopportunity')">Business Opportunity</td>
                  <td v-else>{{ approval.module }}</td>
                  <td>
                    <div>{{ getApprovalOrderNumber(approval) }}</div>
                    <div v-if="approval.module === 'purchase' && approval.purchase?.Supplier?.name" class="text-muted small mt-1">{{ approval.purchase.Supplier.name }}</div>
                  </td>
                  <td>{{ approval.requestedBy?.name || '-' }}</td>
                  <td v-if="activeApproval == 'processed'">{{  approval.approvedBy?.name }}</td>
                  <td v-if="activeApproval == 'processed'">{{  this.formatDate(approval.updatedAt, "true") }}</td>
                  <td v-if="activeApproval == 'processed'" class="capitalize-first">{{  approval.comment }}</td>
                  <td class="approval-status-cell">
                    <button v-if="approval.type == 'approved' && approval.module != 'purchase'" class="btn btn-sm btn-success" style="border-radius: 15px; text-transform: capitalize !important;" >Approved</button>
                    <button v-if="approval.type == 'rejected'" class="btn btn-sm btn-danger" style="border-radius: 15px; text-transform: capitalize !important;">Rejected</button>
                    <button v-if="approval.type == 'pending'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">Pending</button>
                    <!-- Purchases: 3-step vs 4-step by PO net (excl. VAT, after discount) vs CEO threshold -->
                    <button v-if="approval.type == 'verify' && approval.module == 'purchase'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">1/{{ getApprovalDenominator(approval) }} Approved</button>
                    <button v-else-if="approval.type == 'verify'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">1/4 Approved</button>

                    <button v-if="approval.type == 'stamp' && approval.module == 'purchase'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">2/{{ getApprovalDenominator(approval) }} Approved</button>
                    <button v-else-if="approval.type == 'stamp'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">2/4 Approved</button>

                    <button v-if="approval.type == 'ceo_stamp' && approval.module == 'purchase'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">3/{{ getApprovalDenominator(approval) }} Approved</button>
                    <button v-else-if="approval.type == 'ceo_stamp'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">3/4 Approved</button>
                  </td>
                  <td>
                    <button v-if="approval.type =='pending' || approval.type == 'verify' || approval.type == 'stamp' || approval.type == 'ceo_stamp' || approval.type == 'ceostamp'" class="btn btn-sm btn-primary" data-action="approve">Approve</button>
                    <button v-if="approval.type =='pending' || approval.type == 'verify' || approval.type == 'stamp' || approval.type == 'ceo_stamp' || approval.type == 'ceostamp'" class="btn btn-sm btn-danger" style="margin-left: 5px;" data-action="reject">Reject</button>
                    <button class="btn btn-sm btn-default" style="border: 1px solid #000; margin-left: 5px;" data-action="view">View</button>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div v-else>
              <label for="" class="text-danger" style="margin: 0px ; width: fit-content; display: block;">No approval request found</label>
            </div>
          </div>
        </div>
      </section>
      <ApprovalModal v-if="isApprovalModalVisible" @close="closeApprovalModal" >
        <template v-slot:header>
          <h3 style="font-size: 1rem">Request Details</h3>
          <h4 style="font-size: 1rem; font-weight: 600">{{ modalTitle }}</h4> 
        </template>
        <template v-slot:body><div id="modalBody" v-html="getApprovalModalBody(modalApproval, currentPRForPO, loadingPRForPO)"></div></template>
        <template v-slot:footer>
          <button class="btn btn-default" style="border: 1px solid #000" @click="closeApprovalModal"> Close</button>
          <button v-if="modalApproval?.type =='pending'" class="btn btn-primary" @click="processApproval(modalApproval)">Approve</button>
          <button v-if="modalApproval?.type =='pending'" class="btn btn-danger" style="margin-left: 5px;" @click="rejectApproval(modalApproval?.id)">Reject</button>
        </template>
      </ApprovalModal>
      <PurchaseRequestDetailsModal
        v-if="showPurchaseRequestModal"
        :request="purchaseRequestDetails"
        @close="() => { showPurchaseRequestModal = false; purchaseRequestDetails = null; }"
      />
    </div>
  </BDLayout>

  <AppLayout v-else>
    <div class="transaction">
      <section id="transaction-products">
        <div class="container">
            <!--<div style="display:flex;align-items:center;justify-content:space-between;">
            <h6 class="fw-bold text-primary" style="margin:0">Approvals</h6>
            <button class="btn btn-sm btn-outline-primary" @click="refreshApprovals" :disabled="loading">
              <span v-if="loading">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                &nbsp;Fetching Approvals...
              </span>
              <span v-else>Refresh</span>
            </button>
          </div>
        
            <button class="btn-style pull-right" style="margin-top: -50px;float:right;" @click="$router.push('/settings/approvals/pending')">Order Requests</button>
          -->
          <div class="warehouse-inventory-card-wrapper">
            <!--
              <div class="warehouse-inventory-card">
                <p>Pending PO Approvals</p>
                <strong class="blue">0</strong>
              </div>
            -->
            <div class="warehouse-inventory-card" @click="setActiveApproval('pending')" :style="{border: activeApproval === 'pending' ?  '1px solid #cccccc': ''}">
              <p>Pending Approvals</p>
              <strong class="blue">{{ this.pendingApprovals.length }}</strong>
            </div>
            <div class="warehouse-inventory-card" @click="setActiveApproval('urgent')" :style="{border: activeApproval === 'urgent' ?  '1px solid #cccccc': ''}">
              <p>Urgent Approvals</p>
              <strong class="red">{{ urgentApprovals.length }}</strong>
            </div>
            <div class="warehouse-inventory-card"  @click="setActiveApproval('processed')" :style="{border: activeApproval === 'processed' ?  '1px solid #cccccc': ''}">
              <p>Processed Requests</p>
              <strong class="green">{{ this.processedApprovals.length}}</strong>
            </div>
          </div>

          <!-- Summary Statistics Cards -->
          <div class="warehouse-inventory-card-wrapper mt-3">
            <div class="warehouse-inventory-card">
              <p>Total Number</p>
              <strong class="primary">{{ totalApprovals }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Total PO Approvals</p>
              <strong class="info">{{ totalPOApprovals }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Total PR Approvals</p>
              <strong class="warning">{{ totalPRApprovals }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Duration > 2 Months</p>
              <strong class="danger">{{ durationGreaterThanTwoMonths }}</strong>
            </div>
            <div class="warehouse-inventory-card">
              <p>Duration 1-2 Months</p>
              <strong class="secondary">{{ durationOneToTwoMonths }}</strong>
            </div>
          </div>
          <div>
            
            <SkeletonLoader v-if="showSkeleton" type="table" :rows="6" :columns="10" />
            <div v-else-if="activeApprovals?.length > 0" class="approvals-data-table-wrapper">
            <table
              :key="`approvals-${activeApproval}-${isBDSelected ? 'bd' : 'app'}-${tableKeyNonce}`"
              ref="approvalsTableApp"
              id="approvalsTableApp"
              class="table table-sm table-hover mb-0"
              @click="onApprovalsTableClick"
            >
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Date</th>
                  <th>Priority</th>
                  <th>Request</th>
                  <th>Order No.</th>
                  <th>Requester</th>
                  <th v-if="activeApproval == 'processed'">Actioned By</th>
                  <th v-if="activeApproval == 'processed'">Actioned Date</th>
                  <th v-if="activeApproval == 'processed'">Comment</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(approval, index) in activeApprovals" v-bind:key="approval.id" :data-approval-id="approval.id">
                  <td>{{ index+1 }}</td>
                  <td :data-order="approval.createdAt ? new Date(approval.createdAt).getTime() : 0">{{ formatDate(approval.createdAt,"true") }}</td>
                  <td>
                    <button v-if="approval.priority == 'urgent'" class="btn btn-sm btn-danger" style="border-radius: 15px;">Urgent</button>
                    <button v-else class="btn btn-sm btn-primary" style="border-radius: 15px;">Normal</button>
                  </td>
                  <td v-if="approval.module == 'purchase'">Purchase Order</td>
                  <td v-else-if="approval.module == 'pickup'">Pickup Note</td>
                  <td v-else-if="approval.module == 'dispatch'">Dispatch Note</td>
                  <td v-else-if="((approval.module || '').toString().toLowerCase() === 'businessopportunity') || ((approval.module || '').toString().toLowerCase() === 'bidopportunity')">Business Opportunity</td>
                  <td v-else>{{ approval.module }}</td>
                  <td>
                    <div>{{ getApprovalOrderNumber(approval) }}</div>
                    <div v-if="approval.module === 'purchase' && approval.purchase?.Supplier?.name" class="text-muted small mt-1">{{ approval.purchase.Supplier.name }}</div>
                  </td>
                  <td>{{ approval.requestedBy?.name || '-' }}</td>
                  <td v-if="activeApproval == 'processed'">{{  approval.approvedBy?.name }}</td>
                  <td v-if="activeApproval == 'processed'">{{  this.formatDate(approval.updatedAt, "true") }}</td>
                  <td v-if="activeApproval == 'processed'" class="capitalize-first">{{  approval.comment }}</td>
                  <td class="approval-status-cell">
                    <button v-if="approval.type == 'approved' && approval.module != 'purchase'" class="btn btn-sm btn-success" style="border-radius: 15px; text-transform: capitalize !important;" >Approved</button>
                    <button v-if="approval.type == 'rejected'" class="btn btn-sm btn-danger" style="border-radius: 15px; text-transform: capitalize !important;">Rejected</button>
                    <button v-if="approval.type == 'pending'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">Pending</button>
                    <!-- Purchases: 3-step vs 4-step by PO net (excl. VAT, after discount) vs CEO threshold -->
                    <button v-if="approval.type == 'verify' && approval.module == 'purchase'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">1/{{ getApprovalDenominator(approval) }} Approved</button>
                    <button v-else-if="approval.type == 'verify'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">1/4 Approved</button>

                    <button v-if="approval.type == 'stamp' && approval.module == 'purchase'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">2/{{ getApprovalDenominator(approval) }} Approved</button>
                    <button v-else-if="approval.type == 'stamp'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">2/4 Approved</button>

                    <button v-if="approval.type == 'ceo_stamp' && approval.module == 'purchase'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">3/{{ getApprovalDenominator(approval) }} Approved</button>
                    <button v-else-if="approval.type == 'ceo_stamp'" class="btn btn-sm btn-warning" style="border-radius: 15px; text-transform: capitalize !important;">3/4 Approved</button>
                  </td>
                  <td>
                    <button v-if="approval.type =='pending' || approval.type == 'verify' || approval.type == 'stamp' || approval.type == 'ceo_stamp' || approval.type == 'ceostamp'" class="btn btn-sm btn-primary" data-action="approve">Approve</button>
                    <button v-if="approval.type =='pending' || approval.type == 'verify' || approval.type == 'stamp' || approval.type == 'ceo_stamp' || approval.type == 'ceostamp'" class="btn btn-sm btn-danger" style="margin-left: 5px;" data-action="reject">Reject</button>
                    <button class="btn btn-sm btn-default" style="border: 1px solid #000; margin-left: 5px;" data-action="view">View</button>
                  </td>
                </tr>
              </tbody>
            </table>
            </div>
            <div v-else>
              <label for="" class="text-danger" style="margin: 0px ; width: fit-content; display: block;">No approval request found</label>
            </div>
          </div>

           <!-- Compare PR vs PO Modal -->
              <div v-if="showCompareModal" style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1102;padding:20px"> 
                <div style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:1101" @click="closeCompareModal"></div>
                <div style="background:#fff;z-index:1102;max-width:1100px;width:100%;max-height:calc(100vh - 120px);overflow:auto;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.25);padding:16px">
                  <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:11px">
                    <h5 style="margin:0">Compare Purchase Request vs Purchase Order</h5>
                    <div>
                      <button
                        class="btn"
                        style="border:none;background:transparent;width:32px;height:32px;border-radius:9999px;display:inline-flex;align-items:center;justify-content:center;font-size:20px;color:#6b7280;"
                        @click="closeCompareModal"
                        aria-label="Close compare modal"
                      >
                        &times;
                      </button>
                    </div>
                  </div>
                  <div v-if="compareLoading" style="text-align:center;padding:24px;color:#666">Loading...</div>
                  <div v-else style="display:flex;gap:16px;flex-wrap:wrap">
                    <div style="flex:1;min-width:300px">
                      <div
                        v-if="comparePRNotes.description || comparePRNotes.specialInstructions"
                        style="margin-bottom:12px;padding:10px 12px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:6px;font-size:13px;line-height:1.45"
                      >
                        <div v-if="comparePRNotes.description" style="margin-bottom:8px">
                          <div style="font-weight:600;color:#374151;font-size:11px;text-transform:uppercase;letter-spacing:0.02em">Description</div>
                          <div style="white-space:pre-wrap;word-break:break-word">{{ comparePRNotes.description }}</div>
                        </div>
                        <div v-if="comparePRNotes.specialInstructions">
                          <div style="font-weight:600;color:#374151;font-size:11px;text-transform:uppercase;letter-spacing:0.02em">Special instructions</div>
                          <div style="white-space:pre-wrap;word-break:break-word">{{ comparePRNotes.specialInstructions }}</div>
                        </div>
                      </div>
                      <div style="font-weight:700;margin-bottom:8px">Purchase Request Items</div>
                      <table class="table table-sm">
                        <thead><tr><th>Item</th><th>Notes</th><th>Qty Request</th><th>Qty Confirmed for Purchase</th></tr></thead>
                        <tbody>
                          <tr v-for="it in comparePRItems" :key="it.id + '-pr'">
                            <td>{{ it.name }}</td>
                            <td style="max-width:200px;font-size:12px;white-space:pre-wrap;word-break:break-word">{{ it.lineNotes || '—' }}</td>
                            <td>{{ it.qty }}</td>
                            <td>{{ it.qtyProcessed != null ? it.qtyProcessed : '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div style="flex:1;min-width:300px">
                      <div style="font-weight:700;margin-bottom:8px">Purchase Order Items</div>
                      <table class="table table-sm">
                        <thead><tr><th>Item</th><th>Qty</th><th>Unit Price</th></tr></thead>
                        <tbody>
                          <tr v-for="it in comparePOItems" :key="it.id + '-po'">
                            <td>{{ it.name }}</td>
                            <td>{{ it.qty }}</td>
                            <td>{{ it.unitPrice ? new Intl.NumberFormat('en-US',{ style:'currency', currency: 'KES'}).format(it.unitPrice) : '-' }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>


     <!-- Nested Quotation Summary Modal (renders above approval modal) -->
      <div v-if="showQuotationSummaryModal" style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:1102;padding:20px"> 
        <div style="position:fixed;inset:0;background:rgba(0,0,0,0.5);z-index:1101" @click="closeQuotationSummary"></div>
        <div style="background:#fff;z-index:1102;max-width:1100px;width:100%;max-height:calc(100vh - 120px);overflow:auto;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.25);">
          <div style="display:flex;justify-content:space-between;align-items:center;padding:16px 20px;border-bottom:1px solid #eee">
            <div>
              <h5 style="margin:0">Quotation Summary</h5>
              <div style="font-size:11px;color:#666">Tender: {{ modalApproval?.purchase?.Tender?.title || modalApproval?.purchase?.Tender?.referenceNumber || '-' }}</div>
            </div>
            <div>
              <button
                class="btn"
                style="border:none;background:transparent;width:32px;height:32px;border-radius:9999px;display:inline-flex;align-items:center;justify-content:center;font-size:20px;color:#6b7280;"
                @click="closeQuotationSummary"
                aria-label="Close quotation summary"
              >
                &times;
              </button>
            </div>
          </div>
          <!-- Explainer legend -->
          <div style="padding:8px 16px;border-bottom:1px solid #f3f4f6;background:#fbfbfc">
            <div style="display:flex;gap:16px;align-items:center;font-size:11px;color:#333;flex-wrap:wrap">
              <div style="display:flex;align-items:center;gap:8px">
                <span style="display:inline-block;width:11px;height:11px;background:#f59e0b;border-radius:2px"></span>
                <div><strong style="font-size: 11px !important;">Orange price:</strong>&nbsp;Lowest unit price among quotations</div>
              </div>
              
              <div style="display:flex;align-items:center;gap:8px">
                <span style="display:inline-block;background:#fff7ed;color:#92400e;padding:4px 8px;border-radius:6px;font-weight:700">Item</span>
                <div><strong style="font-size: 11px !important;">Maroon highlight:</strong>&nbsp;Supplier / Quoted product that is included on the Purchase Order</div>
              </div>
            </div>
          </div>
             
          <div style="padding:16px">
            <div v-if="quotationLoading" style="text-align:center;padding:24px;color:#666">Loading...</div>
            <div v-else>
              <div v-if="quotationSummary && quotationSummary.length > 0">
                <div style="overflow:auto">
                  <table style="width:100%;border-collapse:collapse">
                    <thead style="background:#fafafa;border-bottom:1px solid #e6eef7">
                      <tr>
                        <th style="text-align:left;padding:11px;border:1px solid #eef2f6">Supplier</th>
                        <th v-for="col in quotationColumns" :key="col" style="text-align:left;padding:11px;border:1px solid #eef2f6">{{ col }}</th>
                        <th style="text-align:left;padding:11px;border:1px solid #eef2f6">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="sub in quotationSummary" :key="sub.id" :style="sub.matchesPoSupplier ? 'background:#fbfafb;border:1px solid #e6eef7' : ''">
                        <td style="padding:10px;border:1px solid #eef2f6">
                          <div style="display:flex;align-items:center;gap:8px">
                            <div :style="'font-weight:700;' + (sub.matchesPoSupplier ? 'color:#92400e;' : '')">
                              {{ sub.companyName || sub.company || ('#'+sub.id) }}
                            </div>
                          </div>
                          <div style="font-size:11px;color:#666">{{ formatDate(sub.createdAt || sub.submittedAt || sub.created) }}</div>
                        </td>
                        <td
                          v-for="col in quotationColumns"
                          :key="col + '-' + sub.id"
                          style="padding:10px;border:1px solid #eef2f6"
                        >
                          <div v-if="sub.priceFor && sub.priceFor[col] != null">
                                <span
                                  :title="isQuotedItemInPO(sub, col) && sub.matchesPoSupplier ? 'Included in Purchase Order (awarded supplier)' : (sub.priceFor && sub.priceFor[col] === quotationColumnMins[col] ? 'Lowest unit price among submissions' : '')"
                                  :style="(isQuotedItemInPO(sub, col) && sub.matchesPoSupplier)
                                    ? 'color:#92400e;font-weight:700;'
                                    : (sub.priceFor[col] === quotationColumnMins[col]
                                        ? 'color:#f59e0b;font-weight:700'
                                        : '')"
                                >
                              {{ new Intl.NumberFormat('en-US',{ style:'currency', currency: sub.quotedCurrency || 'USD'}).format(sub.priceFor[col]) }}
                            </span>
                          </div>
                          <div v-else style="color:#666">-</div>
                        </td>
                        <td style="padding:10px;border:1px solid #eef2f6">{{ (sub.quotedTotal != null) ? (new Intl.NumberFormat('en-US',{ style:'currency', currency: sub.quotedCurrency || 'USD'}).format(sub.quotedTotal)) : '-' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div v-else style="color:#666">No submissions found for this tender.</div>
            </div>
          </div>
        </div>
      </div>
        </div>
      </section>
          
      <ApprovalModal v-if="isApprovalModalVisible" @close="closeApprovalModal" >
        <template v-slot:header>
          <h4 style="font-size: 1rem; font-weight: 600">{{ modalTitle }}</h4> 
        </template>
        <template v-slot:body><div id="modalBody" v-html="getApprovalModalBody(modalApproval, currentPRForPO, loadingPRForPO)"></div></template>
        <template v-slot:footer>
          <button v-if="modalApproval?.type =='pending'" class="btn btn-primary" @click="processApproval(modalApproval)">Approve</button>
          <button v-if="modalApproval?.type =='pending'" class="btn btn-danger" style="margin-left: 5px;" @click="rejectApproval(modalApproval?.id)">Reject</button>
        </template>
      </ApprovalModal>

      <PurchaseRequestDetailsModal
        v-if="showPurchaseRequestModal"
        :request="purchaseRequestDetails"
        @close="() => { showPurchaseRequestModal = false; purchaseRequestDetails = null; }"
      />
  
   </div>
   </AppLayout> 
  
</template>
  
  <script>
  import $ from 'jquery'
  import 'datatables.net-vue3'
  import 'datatables.net-bs5'
  import 'datatables.net-buttons-bs5'
  import 'datatables.net-responsive-bs5'
  import 'datatables.net-buttons/js/buttons.html5.js'
  import 'datatables.net-buttons/js/buttons.colVis.js'
  import 'datatables.net-buttons/js/buttons.print.js'
  import { toast } from 'vue3-toastify';
  import 'vue3-toastify/dist/index.css';
  import Swal from 'sweetalert2'
  import { mapGetters, mapActions } from 'vuex'
  import AppLayout from '../../components/AppLayout.vue';
  import BDLayout from '@/components/BDLayout.vue'
  import ApprovalModal from '../../components/ApprovalModal.vue'
  import PurchaseRequestDetailsModal from '../../components/PurchaseRequestDetailsModal.vue'
  import { isProxy, toRaw } from 'vue';
  import SkeletonLoader from '../../components/SkeletonLoader.vue'
  import { CEO_NET_AMOUNT_THRESHOLD, getPurchaseNetAmountExclusive } from '@/constants/purchaseCeoThreshold.js'

  export default {
    name: 'ApprovalHome',
    components: {
      AppLayout,
      BDLayout,
      ApprovalModal,
      PurchaseRequestDetailsModal,
      SkeletonLoader,
    },
    data: () => ({
        token: JSON.parse(localStorage.getItem('access_token')),
        isApprovalModalVisible: false,
        activeApproval: "pending",
        modalApproval: "",
        modalTitle:"pending ...",
        loading: true,
        dataFetched: false,
        showPurchaseRequestModal: false,
        purchaseRequestDetails: null,
      showQuotationSummaryModal: false,
      processedApprovalsList: [],
      quotationSummary: null,
      quotationLoading: false,
      quotationColumns: [],
      quotationColumnMins: {},
      showCompareModal: false,
      compareLoading: false,
      comparePRItems: [],
      comparePOItems: [],
      comparePRNotes: { justification: '', description: '', specialInstructions: '' },
      currentPRForPO: null,
      loadingPRForPO: false,
      dataTable: null,
      tableKeyNonce: 0,
      reinitTimer: null,
      isReinitializing: false,
      approvalCounts: {},
    }),
    computed:{
        ... mapGetters (["getApprovals"]),
        // read permission from localStorage (fallback to empty)
        permission() { return JSON.parse(localStorage.getItem('permission') || '{}') },
        // detect if Business Development / BID module is selected via local setting or route
        isBDSelected() {
          const stored = localStorage.getItem('active_module') || ''
          if (stored === 'business-development') return true
          const path = this.$route && this.$route.path ? this.$route.path.toString().toLowerCase() : '';
          return path.startsWith('/admin/bid') || path.includes('business-development')
        },
        
        approvals() { return this.getApprovals },
        pendingApprovals () {
          const approvals = this.getApprovals || [];
          const currentUserId = (() => {
            try { return JSON.parse(localStorage.getItem('user') || '{}').id || null } catch(e) { return null }
          })();
          return approvals.filter(approval => {
            const moduleName = (approval.module || '').toString().toLowerCase();
            const t = (approval.type || '').toString().toLowerCase();
            const isPurchaseRequest = moduleName === 'purchase_request' || moduleName === 'purchase-request' || moduleName === 'purchaserequest';

            // Purchase request approvals: show to anyone with approveAll or approvePurchaseRequest
            // Exclude if this user is the requester (self-approval not allowed)
            // Exclude already-approved or rejected entries from the pending list
            if (isPurchaseRequest) {
              if (currentUserId && approval.requestedBy?.id === currentUserId) return false;
              if (t === 'approved' || t === 'rejected') return false;
              return !!(this.permission.approveAll || this.permission.approvePurchaseRequest || this.permission.purchaseRequestProcess);
            }

            // if BD selected, only show BD-related modules (non-PR already handled above)
            if (this.isBDSelected && !['businessopportunity', 'bidopportunity'].includes(moduleName)) return false;
            
            if (moduleName !== 'purchase') {
              return t === 'pending' || t === 'verify' || t === 'verified' || t === 'stamp' || t === 'ceo_stamp';
            }
            // purchase module: show only types the user has permission for
            if (t === 'verify' || t === 'verification') return !!this.permission.verifyPurchase;
            // 'verified' indicates verification completed and ready for stamping
            if (t === 'verified') return !!this.permission.stampPurchase;
            if (t === 'stamp' || t === 'stamping') return !!this.permission.stampPurchase;
            if (t === 'ceo_stamp' || t === 'ceostamp' || t === 'ceo') return !!this.permission.ceoStampPurchase;
            if (t === 'pending' || t === '') return !!this.permission.approvePurchase;
            return false;
          });
        },
        processedApprovals() {
          // Use the fetched processed approvals from backend
          return this.processedApprovalsList;
        },
             
        urgentApprovals() { return (this.pendingApprovals || []).filter(a => a.priority === 'urgent') },
        activeApprovals() { return this.getActiveApprovals() },
        showSkeleton() {
          return this.loading && !this.dataFetched;
        },
        // Summary statistics for cards
        totalApprovals() {
          return this.getApprovals?.length || 0;
        },
        totalPOApprovals() {
          return this.getApprovals?.filter(approval => 
            approval.module === 'purchase'
          ).length || 0;
        },
        totalPRApprovals() {
          const counts = this.approvalCounts || {};
          return (
            counts['purchase_request'] ||
            counts['purchase-request'] ||
            counts['purchaseRequest'] ||
            0
          );
        },
        durationGreaterThanTwoMonths() {
          return this.getApprovals?.filter(approval => {
            if (!approval.durationText) return false;
            const durationText = approval.durationText.toLowerCase();
            // Parse duration like "57 DAYS 21 HRS"
            const daysMatch = durationText.match(/(\d+)\s*days?/);
            if (daysMatch) {
              const days = parseInt(daysMatch[1]);
              return days > 60; // More than 2 months (60 days)
            }
            return false;
          }).length || 0;
        },
        durationOneToTwoMonths() {
          return this.getApprovals?.filter(approval => {
            if (!approval.durationText) return false;
            const durationText = approval.durationText.toLowerCase();
            // Parse duration like "57 DAYS 21 HRS"
            const daysMatch = durationText.match(/(\d+)\s*days?/);
            if (daysMatch) {
              const days = parseInt(daysMatch[1]);
              return days >= 30 && days <= 60; // Between 1-2 months (30-60 days)
            }
            return false;
          }).length || 0;
        },
    },
    watch: {
      // DataTables mutates the DOM; re-init must be serialized to avoid Vue patching into moved nodes
      // (which triggers the `insertBefore` null crash).
      activeApproval() { this.scheduleReinitDataTable() },
      isBDSelected() { this.scheduleReinitDataTable() },
    },
    methods:{
      ... mapActions(['fetchApprovals']),
      onApprovalsTableClick(e) {
        const btn = e.target.closest('[data-action]')
        if (!btn) return
        const row = btn.closest('tr')
        const id = row && row.dataset.approvalId ? parseInt(row.dataset.approvalId, 10) : null
        const action = btn.dataset.action
        const approval = this.activeApprovals.find(a => a.id === id)
        if (!approval) return
        if (action === 'approve') this.processApproval(approval)
        if (action === 'reject') this.rejectApproval(id)
        if (action === 'view') this.showApprovalModal(approval)
      },

      async fetchProcessedApprovals() {
              try {
                this.loading = true;
                const token = this.token;
                const res = await fetch(`${process.env.VUE_APP_URL}/approvals/processed-by-me`, {
                  headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' }
                });
                if (res.ok) {
                  const data = await res.json();
                  this.processedApprovalsList = Array.isArray(data) ? data : (data.data || []);
                } else {
                  this.processedApprovalsList = [];
                }
              } catch (e) {
                this.processedApprovalsList = [];
              } finally {
                this.loading = false;
              }
      },
      scheduleReinitDataTable() {
        if (this.reinitTimer) {
          clearTimeout(this.reinitTimer)
          this.reinitTimer = null
        }
        // Small debounce batches rapid reactive changes during fetch + tab switch.
        this.reinitTimer = setTimeout(() => {
          this.reinitTimer = null
          this.reinitDataTable()
        }, 120)
      },
      reinitDataTable() {
        if (this.isReinitializing) return
        this.isReinitializing = true
        // DataTables can remove/move DOM nodes; force Vue to remount the table wrapper each cycle.
        this.tableKeyNonce += 1
        // Destroy after key bump so Vue doesn't try to patch into DataTables-moved nodes.
        this.$nextTick(() => {
          this.destroyDataTable()
          // Wait a tick for DOM to settle, then init.
          this.$nextTick(() => {
            setTimeout(() => {
              this.initializeDataTable()
              this.isReinitializing = false
            }, 0)
          })
        })
      },
      initializeDataTable() {
        try {
          const el = this.isBDSelected ? this.$refs.approvalsTableBD : this.$refs.approvalsTableApp
          if (!el || !this.activeApprovals?.length) return
          if ($.fn.DataTable.isDataTable(el)) return
          this.dataTable = $(el).DataTable({
            dom: 'Bfrtip',
            responsive: true,
            pageLength: 25,
            language: {
              paginate: {
                previous: '<i class="fas fa-chevron-left"></i>',
                next: '<i class="fas fa-chevron-right"></i>',
              },
            },
            order: [[1, 'desc']],
            buttons: [
              'colvis',
              'pageLength',
              { extend: 'csv', text: 'Export CSV', className: 'btn btn-primary btn-sm' },
              { extend: 'excel', text: 'Export Excel', className: 'btn btn-primary btn-sm' },
              { extend: 'print', text: 'Print', className: 'btn btn-secondary btn-sm' },
            ],
          })
        } catch (err) {
          console.warn('DataTable init failed', err)
        }
      },
      destroyDataTable() {
        try {
          // Destroy on both possible tables; route/module toggles can flip refs mid-teardown.
          const els = [
            this.$refs.approvalsTableBD,
            this.$refs.approvalsTableApp,
            typeof document !== 'undefined' ? document.getElementById('approvalsTableBD') : null,
            typeof document !== 'undefined' ? document.getElementById('approvalsTableApp') : null,
          ].filter(Boolean)

          els.forEach((el) => {
            try {
              if ($.fn.DataTable.isDataTable(el)) {
                // Use `destroy(true)` to fully remove DataTables wrappers.
                // Vue remount is handled via `tableKeyNonce`.
                $(el).DataTable().destroy(true)
              }
            } catch (e) {
              // ignore per-table teardown errors
            }
          })
          this.dataTable = null
        } catch (e) {
          console.warn('DataTable destroy failed', e)
        } finally {
          // Ensure any pending init doesn't run after unmount/teardown.
          try {
            if (this.reinitTimer) {
              clearTimeout(this.reinitTimer)
              this.reinitTimer = null
            }
          } catch (e) {
            // Intentionally ignore teardown-time errors.
          }
        }
      },
      async openQuotationSummary() {
        this.quotationLoading = true;
        this.quotationSummary = null;
        try {
          const token = this.token;
          const tenderId = this.modalApproval?.purchase?.Tender?.id || this.modalApproval?.purchase?.tenderId;
          if (!tenderId) {
            this.quotationSummary = [];
            this.showQuotationSummaryModal = true;
            return;
          }

          const res = await fetch(`${process.env.VUE_APP_URL}/tender/${tenderId}/submissions`, {
            headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' }
          });
          if (!res.ok) {
            this.quotationSummary = [];
            this.showQuotationSummaryModal = true;
            return;
          }

          const data = await res.json();
          let items = [];
          if (Array.isArray(data)) items = data;
          else if (data && Array.isArray(data.data)) items = data.data;
          else if (data && Array.isArray(data.items)) items = data.items;

          const po = this.modalApproval && this.modalApproval.purchase ? this.modalApproval.purchase : null;
          // Build a set of keys representing items included in the PO: ids, names, skus/codes (all lowercased)
          const poItemsSet = new Set();
          if (po) {
            if (Array.isArray(po.PurchaseProduct)) po.PurchaseProduct.forEach(pi => {
              const prod = pi.Product || {};
              if (prod.id != null) poItemsSet.add(String(prod.id).toLowerCase());
              if (prod.name) poItemsSet.add(String(prod.name).trim().toLowerCase());
              if (prod.code) poItemsSet.add(String(prod.code).trim().toLowerCase());
            });
            if (Array.isArray(po.items)) po.items.forEach(it => {
              if (it.productId != null) poItemsSet.add(String(it.productId).toLowerCase());
              if (it.id != null) poItemsSet.add(String(it.id).toLowerCase());
              if (it.name) poItemsSet.add(String(it.name).trim().toLowerCase());
              if (it.productName) poItemsSet.add(String(it.productName).trim().toLowerCase());
              if (it.sku) poItemsSet.add(String(it.sku).trim().toLowerCase());
              if (it.code) poItemsSet.add(String(it.code).trim().toLowerCase());
            });
            // also allow supplier-provided item keys inside top-level PO structure
            if (po.PurchaseProduct && Array.isArray(po.PurchaseProduct)) {
              po.PurchaseProduct.forEach(pp => {
                if (pp.productId) poItemsSet.add(String(pp.productId).toLowerCase());
              });
            }
          }

          const normalized = items.map((s) => {
            let quotedCurrency = s.proposedCurrency || s.quotedCurrency || s.currency || 'USD';
            let quotedTotal = null;
            let parsed = null;

            // Try parsing common parsed payloads
            try {
              const q = s.parsedQuotation || s.quotation || s.quotationJson || s.json || s.parsed || null;
              parsed = q ? (typeof q === 'string' ? JSON.parse(q) : q) : null;
            } catch (e) {
              console.warn('Failed to parse submission quotation', e);
              parsed = null;
            }

            if (parsed && (parsed.total || parsed.total === 0)) quotedTotal = Number(parsed.total);
            if (quotedTotal == null && (s.proposedValue || s.proposedValue === 0)) quotedTotal = s.proposedValue;

            const srcItems = (parsed && (parsed.items || parsed.lines || parsed.products)) || s.items || s.products || [];
            const quotedItems = (Array.isArray(srcItems) ? srcItems : []).map(li => {
              const name = li.name || li.productName || (li.Product && li.Product.name) || li.description || '';
              const qty = li.quantity || li.qty || li.quantityRequested || li.requestedQuantity || 1;
              const unitPrice = (li.unitPrice != null && !isNaN(li.unitPrice)) ? Number(li.unitPrice) : (li.price || li.proposedUnitPrice || li.rate || (li.Product && li.Product.price) || 0);
              const lineTotal = li.total || li.lineTotal || (qty * (unitPrice || 0));
              let includedInPO = false;
              try {
                const keys = [li.productId, li.id, li.sku, li.code, li.productCode, name].map(k => k == null ? '' : String(k).trim().toLowerCase());
                includedInPO = keys.some(k => k && poItemsSet.has(k));
                // fallback: if exact match failed, check whether PO item names include the quoted name (looser match)
                if (!includedInPO && name) {
                  const nameLower = String(name).trim().toLowerCase();
                  for (const pk of poItemsSet) {
                    if (!pk) continue;
                    if (pk.includes(nameLower) || nameLower.includes(pk)) { includedInPO = true; break; }
                  }
                }
              } catch (e) { /* ignore */ }
              return { name, qty, unitPrice, lineTotal, includedInPO };
            });

            const poSupplierName = (po && (po.Supplier && po.Supplier.name)) || (po && po.supplierName) || '';
            const companyName = s.companyName || s.company || s.supplierName || s.name || '';
            const matchesPoSupplier = poSupplierName && companyName && (companyName.toString().toLowerCase() === poSupplierName.toString().toLowerCase());

            return { ...s, quotedTotal, quotedCurrency, parsedQuotation: parsed, quotedItems, matchesPoSupplier };
          });

          // Build column list preserving first-seen order
          const cols = [];
          normalized.forEach(sub => {
            (sub.quotedItems || []).forEach(li => {
              const n = (li.name || '').toString().trim();
              if (n && !cols.includes(n)) cols.push(n);
            });
          });

          // Build per-submission price lookup and minima per column (exclude 0 from lowest bid)
          const colMins = {};
          normalized.forEach(sub => {
            sub.priceFor = {};
            (sub.quotedItems || []).forEach(li => {
              const name = (li.name || '').toString().trim();
              if (!name) return;
              const unit = (li.unitPrice != null && !isNaN(li.unitPrice)) ? Number(li.unitPrice) : (li.lineTotal && li.qty ? Number(li.lineTotal) / Number(li.qty) : (li.lineTotal || null));
              if (unit == null) return;
              sub.priceFor[name] = unit;
              if (unit > 0 && (colMins[name] == null || unit < colMins[name])) colMins[name] = unit;
            });
          });

          this.quotationSummary = normalized;
          this.quotationColumns = cols;
          this.quotationColumnMins = colMins;
          this.showQuotationSummaryModal = true;
        } catch (e) {
          console.error('Failed to load quotation summary', e);
          this.quotationSummary = [];
          this.showQuotationSummaryModal = true;
        } finally {
          this.quotationLoading = false;
        }
      },

      async openComparePRPO() {
        try {
          this.compareLoading = true;
          this.comparePRItems = [];
          this.comparePOItems = [];
          this.comparePRNotes = { justification: '', description: '', specialInstructions: '' };
          let purchase = this.modalApproval && this.modalApproval.purchase ? this.modalApproval.purchase : null;
          if (!purchase) {
            toast.error('No purchase available to compare');
            return;
          }

          // Always ensure we have the full purchase with Tender.purchaseRequest included
          // (enrichPurchaseApproval may not have finished yet when this runs)
          const hasFullData = purchase.PurchaseProduct?.some(pp => pp.Product || pp.Service);
          const hasTenderPR = purchase.Tender?.purchaseRequest?.id || purchase.tenderSubmission?.tender?.purchaseRequest?.id;
          
          if ((!hasFullData || !hasTenderPR) && purchase.id) {
            try {
              const res = await fetch(`${process.env.VUE_APP_URL}/purchases/${purchase.id}`, {
                headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
              });
              if (res.ok) {
                const data = await res.json();
                purchase = data.purchase || data;
                console.log('[ComparePRPO] Fetched full purchase. Tender:', purchase.Tender, 'tenderSubmission:', purchase.tenderSubmission?.tender);
              } else {
                console.error('[ComparePRPO] Purchase fetch failed:', res.status);
              }
            } catch (e) {
              console.warn('Failed to fetch full purchase for compare', e);
            }
          }

          // Build PO items list from the (now-full) purchase data
          const poItems = [];
          if (Array.isArray(purchase.PurchaseProduct)) {
            purchase.PurchaseProduct.forEach(pp => {
              const prod = pp.Product || {};
              const svc = pp.Service || {};
              const name = prod.name || svc.name || pp.name || pp.productName || pp.description || '';
              const unitPrice = pp.unitPrice ?? pp.price ?? prod.price ?? svc.price ?? 0;
              poItems.push({
                id: prod.id || pp.productId || null,
                serviceId: svc.id || pp.serviceId || null,
                name,
                code: prod.code || pp.code || pp.sku || '',
                qty: pp.quantity ?? pp.qty ?? pp.quantityRequested ?? 0,
                unitPrice: Number(unitPrice) || 0
              });
            });
          }
          if (Array.isArray(purchase.items)) {
            purchase.items.forEach(it => {
              poItems.push({
                id: it.productId || it.id || null,
                serviceId: it.serviceId || null,
                name: it.name || it.productName || '',
                code: it.sku || it.code || '',
                qty: it.quantity ?? it.qty ?? 0,
                unitPrice: Number(it.unitPrice ?? it.price ?? 0) || 0
              });
            });
          }

          // determine PR from all possible paths
          const prFromTenderSubmission = purchase.tenderSubmission?.tender?.purchaseRequest;
          const prFromTender = purchase.Tender?.purchaseRequest;
          let pr = prFromTenderSubmission || prFromTender;
          const hasPrItems = pr && pr.items && pr.items.length > 0;

          if (!hasPrItems) {
            const prId =
              (pr && pr.id) ||
              purchase.purchaseRequestId ||
              (purchase.purchaseRequest && purchase.purchaseRequest.id) ||
              this.modalApproval.purchaseRequestId ||
              (this.modalApproval.purchaseRequest && this.modalApproval.purchaseRequest.id);

            console.log('[ComparePRPO] prId:', prId, '| pr from list:', pr);

            if (prId) {
              try {
                const token = this.token;
                const res = await fetch(`${process.env.VUE_APP_URL}/purchase-requests/${prId}`, {
                  headers: { 'Accept': 'application/json', 'Authorization': token ? `Bearer ${token}` : '' }
                });
                console.log('[ComparePRPO] PR fetch status:', res.status);
                if (res.ok) {
                  const data = await res.json();
                  pr = data.data || data || {};
                  console.log('[ComparePRPO] PR items:', pr?.items?.length, '| sample:', JSON.stringify(pr?.items?.[0])?.slice(0, 200));
                } else {
                  const errText = await res.text();
                  console.error('[ComparePRPO] PR fetch error:', res.status, errText);
                }
              } catch (e) {
                console.warn('Failed to fetch purchase request for compare', e);
              }
            } else {
              console.warn('[ComparePRPO] No prId found. purchase keys:', Object.keys(purchase));
            }
          }

          if (!pr) {
            toast.error('No linked purchase request found for this purchase');
            this.comparePOItems = poItems;
            this.showCompareModal = true;
            return;
          }

          this.comparePRNotes = {
            justification: pr.justification == null ? '' : String(pr.justification).trim(),
            description: pr.description == null ? '' : String(pr.description).trim(),
            specialInstructions: pr.specialInstructions == null ? '' : String(pr.specialInstructions).trim(),
          };
          const prItems = [];
          // items are under `items` with nested `product`/`service` per the backend service
          const src = pr.items || pr.products || pr.requestItems || [];
          (Array.isArray(src) ? src : []).forEach(it => {
            const prod = it.product || it.Product || {};
            const svc  = it.service  || it.Service  || {};
            // For free-text PR items (no linked product/service), the name lives in
            // `description` or `productDescription`. Build the name with all fallbacks.
            const itemName = it.name
              || it.productName
              || prod.name
              || svc.name
              || it.description
              || it.productDescription
              || '-';
            // Notes: prefer specifications/preferredBrand when description was used as name
            const hasLinkedItem = prod.name || svc.name;
            const lineDesc = hasLinkedItem
              ? (it.description || it.productDescription || it.specifications || it.preferredBrand || it.notes || '')
              : (it.specifications || it.preferredBrand || it.notes || '');
            const lineNotes = (lineDesc && String(lineDesc).trim()) ? String(lineDesc).trim() : '';
            prItems.push({
              id: it.productId || prod.id || it.id || null,
              serviceId: it.serviceId || svc.id || null,
              name: itemName,
              code: it.sku || it.code || prod.code || svc.code || '',
              qty: it.quantity || it.qty || it.requestedQuantity || 0,
              qtyProcessed: it.quantityProcessed ?? null,
              unitPrice: it.unitPrice || it.price || it.estimatedUnitPrice || 0,
              lineNotes,
            });
          });

          // Enrich PO items with qtyRequest and qtyProcessed from matching PR items
          const findPrItem = (productId, serviceId) =>
            prItems.find(pi => (productId != null && pi.id === productId) || (serviceId != null && pi.serviceId === serviceId));
          poItems.forEach(po => {
            const prMatch = findPrItem(po.id, po.serviceId);
            if (prMatch) {
              po.qtyRequest = prMatch.qty;
              po.qtyProcessed = prMatch.qtyProcessed;
            }
          });

          this.comparePOItems = poItems;
          this.comparePRItems = prItems;
          this.showCompareModal = true;
        } catch (e) {
          console.error('Failed to compare PR vs PO', e);
          toast.error('Failed to compare purchase request and order');
        } finally {
          this.compareLoading = false;
        }
      },

      openPRAttachments() {
        const p = this.modalApproval?.purchase || {};
        const pr = this.currentPRForPO || 
          p.Tender?.purchaseRequest || 
          p.tenderSubmission?.tender?.purchaseRequest || 
          this.modalApproval?.purchaseRequest || 
          null;

        if (!pr) {
          toast.error('No linked purchase request found');
          return;
        }
        this.purchaseRequestDetails = pr;
        this.showPurchaseRequestModal = true;
      },

      closeQuotationSummary() {
        this.showQuotationSummaryModal = false;
        this.quotationSummary = null;
      },
      // close compare modal
      closeCompareModal() {
        this.showCompareModal = false;
        this.comparePRItems = [];
        this.comparePOItems = [];
        this.comparePRNotes = { justification: '', description: '', specialInstructions: '' };
      },
      ... mapActions(['fetchApprovals','fetchBusinessApprovals']),
      async refreshApprovals() {
        try {
          this.loading = true;
          this.dataFetched = false;
          if (this.isBDSelected) await this.fetchBusinessApprovals();
          else await this.fetchApprovals();
          await this.fetchApprovalCounts();
        } catch (e) {
          console.error('Failed to refresh approvals', e);
          toast.error('Failed to refresh approvals');
        } finally {
          this.loading = false;
          this.dataFetched = true;
          this.scheduleReinitDataTable()
        }
      },
      async fetchApprovalCounts() {
        try {
          const res = await fetch(`${process.env.VUE_APP_URL}/approvals/count`, {
            headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
          });
          if (res.ok) {
            const data = await res.json();
            this.approvalCounts = data.data || {};
          }
        } catch (e) {
          console.error('Failed to fetch approval counts', e);
        }
      },
      async showApprovalModal (obj) {
        if (!obj) return;

        // Handle redirects for specific modules
        if (obj.module === 'DispatchNote' && obj.dispatchNote) {
          this.$router.push(`/orders/dispatch/pdf/${obj.dispatchNote.id}`);
          return;
        } else if (obj.module === 'PickupNote' && obj.pickupNote) {
          this.$router.push(`/orders/pickup/pdf/${obj.pickupNote.id}`);
          return;
        }

        // Handle Purchase Request modal logic
        const isPR = ['purchase_request', 'purchase-request', 'purchaseRequest'].includes(obj.module);
        if (isPR) {
          try {
            const token = this.token;
            const requestId = obj.purchaseRequestId || obj.moduleId || obj.requestId || obj.id;
            const res = await fetch(`${process.env.VUE_APP_URL}/purchase-requests/${requestId}`, {
              headers: { Authorization: token ? `Bearer ${token}` : '' }
            });
            if (res.ok) {
              const data = await res.json();
              this.purchaseRequestDetails = data.data || data;
              this.showPurchaseRequestModal = true;
              return;
            }
          } catch (e) {
            console.error('Failed to load purchase request details', e);
          }
        }

        // 1. Set basic modal data immediately for instant display
        this.modalApproval = obj;
        this.isApprovalModalVisible = true;
        this.modalTitle = this.getApprovalModaltitle(this.modalApproval.module);

        // 2. Perform background enrichment without blocking the modal
        const moduleLower = ((obj.module || '') + '').toString().toLowerCase();
        
        if (moduleLower === 'purchase') {
          this.enrichPurchaseApproval(obj);
        } else if (['businessopportunity', 'bidopportunity'].includes(moduleLower)) {
          this.enrichOpportunityApproval(obj);
        }
      },

      async enrichPurchaseApproval(obj) {
        this.loadingPRForPO = true;
        try {
          const purchaseId = obj.purchase?.id || obj.moduleId || obj.purchaseId || obj.id;
          if (!purchaseId) return;

          const res = await fetch(`${process.env.VUE_APP_URL}/purchases/${purchaseId}`, {
            headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
          });
          
          if (res.ok) {
            const data = await res.json();
            const fullPurchase = data.purchase || data;
            let submissionsCount = fullPurchase?.Tender?._count?.submissions ?? null;
            
            if (submissionsCount == null) {
              const tenderId = fullPurchase?.Tender?.id;
              if (tenderId) {
                const sres = await fetch(`${process.env.VUE_APP_URL}/tender/${tenderId}/submissions`, {
                  headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
                });
                if (sres.ok) {
                  const sdata = await sres.json();
                  submissionsCount = sdata.total ?? sdata.length ?? sdata.data?.length ?? sdata.items?.length ?? sdata.count ?? null;
                }
              }
            }
            // Fetch PR details with attachments if PR is associated
            const prFromSubmission = fullPurchase.tenderSubmission?.tender?.purchaseRequest;
            const prFromTender = fullPurchase.Tender?.purchaseRequest;
            const pr = prFromSubmission || prFromTender || fullPurchase.purchaseRequest || null;
            if (pr) {
              this.currentPRForPO = pr;
            }
            const prId = pr?.id || fullPurchase.purchaseRequestId || (fullPurchase.purchaseRequest && fullPurchase.purchaseRequest.id);
            if (prId) {
              try {
                const prRes = await fetch(`${process.env.VUE_APP_URL}/purchase-requests/${prId}`, {
                  headers: { 'Accept': 'application/json', 'Authorization': this.token ? `Bearer ${this.token}` : '' }
                });
                if (prRes.ok) {
                  const prData = await prRes.json();
                  this.currentPRForPO = prData.data || prData;
                }
              } catch (prErr) {
                console.error('Failed to load PR attachments for PO view', prErr);
              }
            } else if (!pr) {
              this.currentPRForPO = null;
            }

            // Update reactive property to trigger v-html re-render
            this.modalApproval = { ...obj, purchase: fullPurchase, tenderSubmissionsCount: submissionsCount };
          }
        } catch (e) {
          console.error('Failed to enrich purchase approval data', e);
        } finally {
          this.loadingPRForPO = false;
        }
      },

      async enrichOpportunityApproval(obj) {
        try {
          if (obj.opportunity) return;
          const details = obj.details || '';
          const m = details.match(/\[(\d+)\]/);
          const oppId = m ? m[1] : (obj.moduleId || obj.moduleId || obj.opportunityId || obj.module_id || obj.opportunity_id || null);
          
          if (oppId) {
            const res = await fetch(`${process.env.VUE_APP_URL}/opportunities/${oppId}`, { 
              headers: { Authorization: this.token ? `Bearer ${this.token}` : '' } 
            });
            if (res.ok) {
              const payload = await res.json();
              const opportunity = payload.data || payload;
              // Update reactive property
              this.modalApproval = { ...obj, opportunity };
              console.debug('Approval modal loaded opportunity in background', opportunity);
            }
          }
        } catch (e) {
          console.error('Error enriching opportunity for approval modal', e);
        }
      },

      getApprovalModaltitle(value) {
        switch (value){
          case "purchase": return "Purchase Order"
          case "StockReleased" : return "Release Reserved Stock"
          case "StockAdjustment" : return "Stock Adjustment"
          case "StockTransfer" : return "Stock Transfer"
          default: return ""
        }
      },

      setActiveApproval(arg){
        this.activeApproval = arg
      },

      getActiveApprovals(){
        let arr
        switch(this.activeApproval){
          case "urgent":
            arr = this.urgentApprovals
            break
          case "pending":
            arr = this.pendingApprovals
            break
          case "processed":
            arr = this.processedApprovals
            break
          default:
            arr = []
        }
        return [...(arr || [])].sort((a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
        )
      },
      
      getApprovalModalBody(data, prForPO, prLoading) {
        let approval=""
        if (isProxy(data)){
          approval = toRaw(data)
        } else { approval = data }

        switch (approval.module){
          case "purchase_request":
          case "purchase-request":
          case "purchaseRequest": {
            const req = approval.purchaseRequest || approval.request || approval.purchaseRequestData || {};
            const date = approval.createdAt || req.createdAt || req.requestedAt || '';
            const dept = req.Department?.name || req.department || req.departmentName || '-';
            const project = req.project || req.projectName || '-';
            const requester = approval.requestedBy?.name || req.requestedBy?.name || req.User?.name || '-';
            const itemsCount = (req.items && req.items.length) || (req.products && req.products.length) || 0;
            const estimated = req.estimatedAmount != null ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: req.currency || 'KES' }).format(Number(req.estimatedAmount))) : (req.amount != null ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: req.currency || 'KES' }).format(Number(req.amount))) : '-');

            return `
              <div style='font-family:system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial; color:#222;'>
                <div style='background:#fff;border-radius:8px;box-shadow:0 6px 20px rgba(31,41,55,0.08);padding:18px;margin-bottom:11px;border:1px solid #ececec'>
                  <div style='display:flex;justify-content:space-between;align-items:flex-start;gap:16px;margin-bottom:11px'>
                    <div>
                      <div style='font-size:11px;color:#666;margin-bottom:6px'>Purchase Request</div>
                      <div style='font-weight:700;font-size:18px'>${req.referenceNumber || ('PR#' + (req.id || ''))}</div>
                    </div>
                    <div style='text-align:right'>
                      <div style='font-size:11px;color:#666;margin-bottom:6px'>Requester</div>
                      <div style='font-weight:600'>${requester}</div>
                      <div style='margin-top:8px;font-size:11px;color:#666'>Date: <span style='font-weight:600;color:#333'>${date ? (new Date(date)).toLocaleString() : '-'}</span></div>
                    </div>
                  </div>

                  <table style='width:100%;border-collapse:collapse;margin-bottom:11px'>
                    <tr>
                      <td style='width:28%;padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Department</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:600'>${dept}</td>
                    </tr>
                    <tr>
                      <td style='padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Project</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:600'>${project}</td>
                    </tr>
                    <tr>
                      <td style='padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Items</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:600'>${itemsCount}</td>
                    </tr>
                    <tr>
                      <td style='padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Estimated Amount</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:700'>${estimated}</td>
                    </tr>
                  </table>

                  <div style='display:flex;justify-content:flex-end;gap:8px'>
                    <a class='btn btn-sm btn-primary' href="/purchase-requests/pdf/${req.id}">View Purchase Request</a>
                  </div>
                </div>
              </div>
            `;
          }
          case "purchase": {
            const p = approval.purchase || {};
            const isFetching = !p.PurchaseProduct && !p.items;
            const skel = (w = '80%', h = '14px') => `<div class="skeleton-shimmer" style="width:${w};height:${h};background:#eee;border-radius:4px;animation:shimmer 1.5s infinite linear;"></div>`;

            const dept = p.Department?.name || p.department || '-';
            const supplier = p.Supplier ? `${p.Supplier.name || '-'}${p.Supplier.phone ? ' - ' + p.Supplier.phone : ''}` : (isFetching ? skel('60%') : '-');
            const poNo = p.purchaseNo || '-';
            const createdBy = p.User?.name || '-';
            const itemsCount = (p.PurchaseProduct && p.PurchaseProduct.length) || (p.items && p.items.length) || (isFetching ? skel('20%') : 0);
            const amount = p.amount != null ? (new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' }).format(Number(p.amount))) : (isFetching ? skel('30%') : '-');
            const discount = p.discount != null ? p.discount : (isFetching ? skel('10%') : '-');
            const vat = p.vat ? 'Yes' : 'No';
            const submissions = approval.tenderSubmissionsCount != null ? approval.tenderSubmissionsCount : (p.Tender && p.Tender.submissions ? p.Tender.submissions.length : (isFetching ? skel('10%') : '-'));
            
            const prFromSubmission = p.tenderSubmission && p.tenderSubmission.tender && p.tenderSubmission.tender.purchaseRequest;
            const prFromTender = p.Tender && p.Tender.purchaseRequest;
            const pr = prForPO || prFromSubmission || prFromTender || p.purchaseRequest || null;
            const requesterName = (pr && pr.requestedBy && pr.requestedBy.name)
              || (pr && pr.requester && pr.requester.name)
              || (pr && pr.requestedByName)
              || (p.User && p.User.name)
              || createdBy;
            const requestDateRaw = (pr && pr.createdAt) || p.createdAt || approval.createdAt;
            const requestDate = requestDateRaw
              ? (new Date(requestDateRaw)).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
              : '';
            
            let approvalHistory = '';
            try {
              const aprs = p.Approval || approval.Approval || [];
              const historyEntries = Array.isArray(aprs)
                ? aprs.filter((a) => {
                    if (!a) return false;
                    const statusNorm = (a.status || '').toString().trim().toLowerCase();
                    if (statusNorm !== 'done') return false;
                    const rawComment = (a.comment || a.notes || a.remark || a.approvalComment) || '';
                    const normalized = rawComment.toString().trim().toLowerCase();
                    return normalized !== 'auto-approved by creator';
                  })
                : [];

              if (historyEntries.length > 0) {
                approvalHistory = '<div style="display:flex;flex-direction:column;gap:6px;margin:0;padding:0">';
                historyEntries.forEach((a, idx) => {
                  const name = (a.approvedBy && a.approvedBy.name) || (a.requestedBy && a.requestedBy.name) || '-';
                  const dt = a.updatedAt || a.approvedAt || a.createdAt || '';
                  const dateStr = dt ? (new Date(dt)).toLocaleString(undefined, { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }) : '';
                  const t = (a.type || '').toString().toLowerCase();
                  let circleBg = '#ddd';
                  let circleColor = '#666';
                  if (t === 'rejected' || t === 'reject') { circleBg = '#dc2626'; circleColor = '#fff'; }
                  else if (t === 'approved' || t === 'verified' || t === 'verify' || t === 'stamp' || t === 'ceo_stamp' || t === 'ceostamp') { circleBg = '#16a34a'; circleColor = '#fff'; }
                  const comment = a.comment || a.notes || a.remark || a.approvalComment || '';
                  approvalHistory += `\n                    <div style="display:flex;gap:11px;align-items:flex-start">\n                      <div style="display:flex;flex-direction:column;align-items:center">\n                        <div style="width:13px;height:13px;border-radius:50%;background:${circleBg};color:${circleColor};display:flex;align-items:center;justify-content:center;font-size:11px;"></div>\n                        ${idx < historyEntries.length - 1 ? '<div style="width:2px;height:28px;background:#e9e9e9;margin-top:4px"></div>' : ''}\n                      </div>\n                      <div style="flex:1">\n                        <div style="font-weight:700;text-transform:capitalize">${(a.type || '').toString()}</div>\n                        <div style="font-size:11px;color:#333">${name}</div>\n                        <div style="font-size:11px;color:#777">${dateStr}</div>\n                        ${comment ? `<div style="margin-top:6px;font-size:11px;color:#555;font-style:italic;">${comment}</div>` : ''}\n                      </div>\n                    </div>`;
                });
                approvalHistory += '</div>';
              } else {
                approvalHistory = '<div style=\'color:#666\'>' + (isFetching ? skel('100%', '40px') : '-') + '</div>';
              }
            } catch (e) {
              approvalHistory = '<div style=\'color:#666\'>-</div>';
            }

            return `
              <div style='font-family:system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial; color:#222;'>
                <div style='background:#fff;border-radius:8px;box-shadow:0 6px 20px rgba(31,41,55,0.08);padding:18px;margin-bottom:11px;border:1px solid #ececec'>
                  <div style='display:flex;justify-content:space-between;align-items:flex-start;gap:16px;margin-bottom:11px'>
                    <div>
                      <div style='font-size:11px;color:#666;margin-bottom:6px'>Purchase Order</div>
                      <div style='font-weight:700;font-size:16px'>${poNo}</div>
                    </div>
                    <div style='text-align:right'>
                      <div style='display:flex;align-items:center;gap:6px;justify-content:flex-end;margin-bottom:6px'>
                        <div style='font-size:11px;color:#666'>Created By</div>
                        <div style='font-weight:600;font-size:13px'>${createdBy}</div>
                      </div>
                      <div style='margin-top:8px;font-size:11px;color:#666'>Department: <span style='font-weight:600;color:#333'>${dept}</span></div>
                    </div>
                  </div>

                  <table style='width:100%;border-collapse:collapse;margin-bottom:11px'>
                    <tr>
                      <td style='width:28%;padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Project</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:600'>${p.project || '-'}</td>
                    </tr>
                    <tr>
                      <td style='padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Items</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:600'>${itemsCount}</td>
                    </tr>
                    <tr>
                      <td style='padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Amount</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:700'>${amount}</td>
                    </tr>
                    <tr>
                      <td style='padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Discount / VAT</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:600'>${discount} / ${vat}</td>
                    </tr>
                    <tr>
                      <td style='padding:10px 8px;color:#666;font-size:11px;border-bottom:1px solid #f0f0f0'>Total Quotations</td>
                      <td style='padding:10px 8px;border-bottom:1px solid #f0f0f0;font-weight:600'>${submissions}</td>
                    </tr>
                    <tr>
                      <td style='padding:10px 8px;color:#666;font-size:11px'>Supplier</td>
                      <td style='padding:10px 8px;font-weight:600'>${supplier}</td>
                    </tr>
                  </table>

                  ${(pr && pr.justification) ? `
                    <div style="margin-bottom:14px;padding:12px;background:#fef3c7;border:1px solid #f59e0b;border-radius:6px;font-size:12px">
                      <div style="font-weight:700;color:#92400e;margin-bottom:4px;text-transform:uppercase;font-size:10px;letter-spacing:0.02em">Purpose of Purchase</div>
                      <div style="color:#78350f;line-height:1.5;white-space:pre-wrap">${pr.justification}</div>
                    </div>
                  ` : (isFetching ? `<div style="margin-bottom:14px;padding:12px;background:#fef3c7;border:1px solid #f59e0b;border-radius:6px;">${skel('30%', '10px')}<div style="margin-top:8px">${skel('100%')}</div><div style="margin-top:4px">${skel('90%')}</div></div>` : '')}

                  ${(function buildItemsTable() {
                    const prods = p.PurchaseProduct || p.items || [];
                    if (isFetching) {
                      let rows = '';
                      for(let i=0; i<3; i++) {
                        rows += `<tr><td style="padding:8px;border:1px solid #eee">${skel('100%')}</td><td style="padding:8px;border:1px solid #eee;text-align:right">${skel('60%')}</td><td style="padding:8px;border:1px solid #eee;text-align:right">${skel('60%')}</td><td style="padding:8px;border:1px solid #eee;text-align:right">${skel('60%')}</td><td style="padding:8px;border:1px solid #eee;text-align:right">${skel('80%')}</td><td style="padding:8px;border:1px solid #eee;text-align:right">${skel('80%')}</td></tr>`;
                      }
                      return '<div style="margin-top:11px;margin-bottom:11px"><div style="font-weight:700;margin-bottom:6px">Items</div><table style="width:100%;border-collapse:collapse;font-size:11px"><thead><tr style="background:#f8f9fa"><th style="text-align:left;padding:8px;border:1px solid #eee">Item</th><th style="text-align:right;padding:8px;border:1px solid #eee">Qty Request</th><th style="text-align:right;padding:8px;border:1px solid #eee">Qty Confirmed</th><th style="text-align:right;padding:8px;border:1px solid #eee">Qty Ordered</th><th style="text-align:right;padding:8px;border:1px solid #eee">Unit Price</th><th style="text-align:right;padding:8px;border:1px solid #eee">Line Total</th></tr></thead><tbody>' + rows + '</tbody></table></div>';
                    }
                    if (!Array.isArray(prods) || prods.length === 0) return '';
                    const pr = p.Tender?.purchaseRequest || p.tenderSubmission?.tender?.purchaseRequest || null;
                    const prItems = (pr && pr.items) ? pr.items : [];
                    const findPrItem = (productId, serviceId) => {
                      return prItems.find(it => (productId != null && it.productId === productId) || (serviceId != null && it.serviceId === serviceId));
                    };
                    const fmt = (n) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'KES' }).format(n);
                    let rows = '';
                    prods.forEach(pp => {
                      const prod = pp.Product || {};
                      const svc = pp.Service || {};
                      const name = (prod.name || svc.name || pp.name || pp.productName || pp.description || '-').toString();
                      const qtyOrdered = pp.quantity ?? pp.qty ?? 0;
                      const prItem = findPrItem(pp.productId, pp.serviceId);
                      const qtyRequest = prItem ? (prItem.quantity ?? '-') : '-';
                      const qtyProcessed = prItem ? (prItem.quantityProcessed ?? '-') : '-';
                      const unitPrice = pp.unitPrice ?? pp.price ?? prod.price ?? svc.price ?? 0;
                      const lineTotal = qtyOrdered * (Number(unitPrice) || 0);
                      rows += '<tr><td style="padding:8px;border:1px solid #eee">' + name + '</td><td style="padding:8px;border:1px solid #eee;text-align:right">' + qtyRequest + '</td><td style="padding:8px;border:1px solid #eee;text-align:right">' + qtyProcessed + '</td><td style="padding:8px;border:1px solid #eee;text-align:right">' + qtyOrdered + '</td><td style="padding:8px;border:1px solid #eee;text-align:right">' + fmt(unitPrice) + '</td><td style="padding:8px;border:1px solid #eee;text-align:right;font-weight:600">' + fmt(lineTotal) + '</td></tr>';
                    });
                    return '<div style="margin-top:11px;margin-bottom:11px"><div style="font-weight:700;margin-bottom:6px">Items</div><table style="width:100%;border-collapse:collapse;font-size:11px"><thead><tr style="background:#f8f9fa"><th style="text-align:left;padding:8px;border:1px solid #eee">Item</th><th style="text-align:right;padding:8px;border:1px solid #eee">Qty Request</th><th style="text-align:right;padding:8px;border:1px solid #eee">Qty Confirmed</th><th style="text-align:right;padding:8px;border:1px solid #eee">Qty Ordered</th><th style="text-align:right;padding:8px;border:1px solid #eee">Unit Price</th><th style="text-align:right;padding:8px;border:1px solid #eee">Line Total</th></tr></thead><tbody>' + rows + '</tbody></table></div>';
                  })()}

                    <div style='display:flex;justify-content:flex-end;gap:8px'>
                    <a class='btn btn-sm btn-primary' href="/purchases/pdf/${p.id}">View Purchase Order</a>
                    <button class='btn btn-sm btn-secondary' style='border:1px solid #e5e7eb;padding:6px 10px;border-radius:6px' onclick="(window.__openComparePRPO && window.__openComparePRPO())">Compare PR vs PO</button>
                    <button class='btn btn-sm' style='background:#f59e0b;color:#fff;border:none;border-radius:9999px;padding:6px 14px' onclick="(window.__openQuotationSummary && window.__openQuotationSummary())">View Quotation Summary</button>
                    ${(pr || prForPO) ? `<button class='btn btn-sm btn-info' style='background:#0dcaf0;color:#fff;border:none;border-radius:4px;padding:6px 10px' onclick="(window.__openPRAttachments && window.__openPRAttachments())">${((pr || prForPO).attachments && (pr || prForPO).attachments.length) ? `View PR Attachments (${(pr || prForPO).attachments.length})` : 'View PR Details'}</button>` : (prLoading ? `<span class='btn btn-sm' style='background:#e5e7eb;color:#9ca3af;border:none;border-radius:4px;padding:6px 10px;cursor:default'><span style='display:inline-block;width:80px;height:10px;background:#d1d5db;border-radius:4px;animation:pulse 1.5s infinite'></span></span>` : '')}
                  </div>
                </div>

                <div style='background:#fff;border-radius:8px;padding:13px;border:1px solid #ececec'>
                  <div style='font-weight:700;margin-bottom:4px'>Approval History</div>
                  <!--<div style='font-size:11px;color:#374151;margin-bottom:8px'>
                    <div><span style='font-weight:600'>Requester:</span> ${requesterName || '-'}</div>
                    <div><span style='font-weight:600'>Req Dt:</span> ${requestDate || '-'}</div>
                  </div>-->
                  ${approvalHistory}
                </div>
              </div>
            `;
          }
        }

        const moduleName = (approval.module || '').toString();
        switch (moduleName){
          case "purchase": return "<table class='table table-bordered'><tr><th>Status</th><td>"+approval.type+"</td></tr><tr><th>Purchase Order Number</th><td>"+approval.purchase?.purchaseNo
            +"</td></tr><tr><th>Department</th><td>"+approval.purchase?.Department.name+"</td></tr><tr><th>Project</th><td>"+approval.purchase?.project
            +"</td></tr><tr><th>Supplier</th><td>"+approval.purchase?.Supplier?.name+" - "+approval.purchase?.Supplier?.phone
            +"</td></tr><tr><th>Purchase Order Created By</th><td>"+(approval.purchase?.User?.name || '-')+"</td></tr></table><a class='btn btn-sm btn-primary' href=\"/purchases/pdf/"+
            approval.purchase.id+"\">View Purchase Order</a>"

          case "StockReleased" : return "<table class='table table-bordered'><tr><th>Priority</th><td style='text-transform: capitalize;'>"+approval.priority+"</td></tr><tr><th>Status</th><td style='text-transform: capitalize;'>"+
            approval.type+"</td></tr><tr><th>Product</th><td>"+approval.stockReservedActivity?.StockReserved?.Product?.name+" - "+approval.stockReservedActivity?.StockReserved?.Product?.code
              +"</td></tr><tr><th>Unit</th><td>"+approval.stockReservedActivity?.StockReserved?.Product?.unit.unit
            +"</td></tr><tr><th>Quantity Requested</th><td>"+approval.stockReservedActivity?.quantityReleased
            +"</td></tr><tr><th>Comment</th><td>"+approval.stockReservedActivity?.note
            +"</td></tr><tr><th>Quantity Reserved</th><td>"+approval.stockReservedActivity?.StockReserved?.quantity
            +"</td></tr><tr><th>Warehouse</th><td>"+approval.stockReservedActivity?.StockReserved?.Inventory?.Warehouse?.name +" - "+approval.stockReservedActivity?.StockReserved?.Inventory?.Warehouse?.description
            +"</td></tr><tr><th>Quantity Available</th><td>"+approval.stockReservedActivity?.StockReserved?.Inventory.quantity
              +"</td></tr><tr><th>Requester</th><td>"+approval?.requestedBy?.name+"</td></tr></table>"

          case "StockAdjustment" : return "<table class='table table-bordered'><tr><th>Priority</th><td>"+approval.priority+"</td></tr><tr><th>Status</th><td>"+
            approval.type+"</td></tr><tr><th>Product</th><td>"+approval.stockAdjustment?.Product?.name+" - "+approval.stockAdjustment?.Product?.code
              +"</td></tr><tr><th>Unit</th><td>"+approval.stockAdjustment?.Product?.unit.unit
            +"</td></tr><tr><th>Type of Adjustment</th><td>"+approval.stockAdjustment?.type
            +"</td></tr><tr><th>Comment</th><td>"+approval.stockAdjustment?.comment
            +"</td></tr><tr><th>Current Quantity</th><td>"+approval.stockAdjustment?.oldQuantity
            +"</td></tr><tr><th>Quantity Change</th><td>"+approval.stockAdjustment?.quantity
            +"</td></tr><tr><th>New Quantity</th><td>"+approval.stockAdjustment?.newQuantity
            +"</td></tr><tr><th>Warehouse</th><td>"+approval.stockAdjustment?.Inventory?.Warehouse?.name +" - "+approval.stockAdjustment?.Inventory?.Warehouse?.description
            +"</td></tr><tr><th>Requester</th><td>"+approval?.requestedBy?.name+"</td></tr></table>"

          case "StockTransfer" : return "<table class='table table-bordered'><tr><th>Priority</th><td>"+approval.priority+"</td></tr><tr><th>Status</th><td>"+
            approval.type+"</td></tr><tr><th>Product</th><td>"+approval.stockTransfer?.Product?.name+" - "+approval.stockTransfer?.Product?.code
              +"</td></tr><tr><th>Unit</th><td>"+approval.stockTransfer?.Product?.unit.unit
            +"</td></tr><tr><th>Quantity</th><td>"+approval.stockTransfer?.quantity
            +"</td></tr><tr><th>Comment</th><td>"+approval.stockTransfer?.comment
            +"</td></tr><tr><th>Old Warehouse</th><td>"+approval.stockTransfer?.Inventory?.Warehouse?.name +" - "+approval.stockTransfer?.Inventory?.Warehouse?.description
            +"</td></tr><tr><th>Quantity Available</th><td>"+approval.stockTransfer?.Inventory.quantity+"</td></tr><tr><th>New Warehouse</th><td>"+
              approval.stockTransfer?.Warehouse?.name+" - "+approval.stockTransfer?.Warehouse?.description+"</td></tr><tr><th>Requester</th><td>"+
                approval?.requestedBy?.name+"</td></tr></table>"

          case "BidOpportunity":
          case "BusinessOpportunity":
          case "bidopportunity":
          case "businessopportunity": {
            const opp = approval.opportunity || {};
            // Attempt multiple fallback shapes for each property (API may return ids or nested objects)
            const clientName = (opp.client && opp.client.name) ? opp.client.name : (opp.clientName || opp.client_name || opp.client || '');
            const sectorName = (opp.sector && opp.sector.name) ? opp.sector.name : (opp.sectorName || opp.sector_name || opp.sector || '');
            const deptName = (opp.department && opp.department.name) ? opp.department.name : (opp.departmentName || opp.department_name || opp.department || '');
            const countryName = (opp.country && opp.country.name) ? opp.country.name : (opp.countryName || opp.country_name || opp.country || '');
            const title = opp.title || opp.name || opp.opportunityTitle || opp.opportunity_name || '';
            const submissionDeadline = opp.submissionDeadline || opp.deadline || opp.closingDate || opp.endDate || opp.submission_deadline || '';
            const formattedDeadline = (function(){
              try{
                if(!submissionDeadline) return '';
                if(typeof submissionDeadline === 'string' && typeof this !== 'undefined' && this.formatDate) return this.formatDate(submissionDeadline, 'true');
                const d = new Date(submissionDeadline);
                return isNaN(d.getTime()) ? submissionDeadline : d.toLocaleString();
              }catch(e){
                try{ const d = new Date(submissionDeadline); return isNaN(d.getTime()) ? submissionDeadline : d.toLocaleString(); }catch(_) { return submissionDeadline || ''; }
              }
            }).call(this);
            const source = opp.source || opp.url || opp.link || '';
            const sourceHref = source && !/^https?:\/\//i.test(source) ? ('http://' + source) : source;
            return "<table class='table table-bordered'>"+
              "<tr><th>Title</th><td>"+title+"</td></tr>"+
              "<tr><th>Client</th><td>"+clientName+"</td></tr>"+
              "<tr><th>Sector</th><td>"+sectorName+"</td></tr>"+
              "<tr><th>Department</th><td>"+deptName+"</td></tr>"+
              "<tr><th>Country</th><td>"+countryName+"</td></tr>"+
              "<tr><th>Source</th><td>"+(source ? ("<a href='"+sourceHref+"' target='_blank' rel='noopener'>"+source+"</a>") : "")+"</td></tr>"+
              "<tr><th>Submission Deadline</th><td>"+formattedDeadline+"</td></tr>"+
              "<tr><th>Requester</th><td style=\"color: orange;\">"+(approval.requestedBy && approval.requestedBy.name ? approval.requestedBy.name : '')+"</td></tr>"+
              "</table>";
          }

          default: return "Details not found. Refresh the page and try again"
        }
      },

      closeApprovalModal() {
        this.isApprovalModalVisible = false;
      },

      async processApproval (approval) {
        const approvalId = approval?.id;
        if (!approvalId) return;
        this.closeApprovalModal()
        Swal.fire({
            title: "Approval Comment (Optional)",
            input: "text",
            inputAttributes: {
              autocapitalize: "off"
            },
            showCancelButton: true,
            confirmButtonText: "OK",
            showLoaderOnConfirm: true,
            preConfirm: async (comment) => {
              await this.approve(approvalId, comment, approval);
            },       
        }).then((result) => {
          if (result.isConfirmed) {
            //toast.success('Approval request accepted');
          }
        })

      },

      async approve(approvalId, comment, approval){ 
        const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ 
                  approvalId,
                  comment
              })
          };
          const res= await fetch(process.env.VUE_APP_URL+'/approvals', requestOptions)
          console.log("Approval Response", res)
          const data = await res.json()
          if(data.status == true){
            toast.success(data.message || 'Approval request accepted');
            if (this.isBDSelected) await this.fetchBusinessApprovals(); else await this.fetchApprovals();
            // Redirect to purchase request processing page when approving a purchase request
            const isPurchaseRequest = approval && (
              approval.module === 'purchase_request' ||
              approval.module === 'purchase-request' ||
              approval.module === 'purchaseRequest'
            );
            if (isPurchaseRequest) {
              const prId = approval.purchaseRequestId || approval.moduleId || approval.requestId || approval.id;
              if (prId) {
                this.$router.push(`/transaction/purchase-request/view/${prId}`);
              }
            }
          }else{
            toast.error(data.message || 'Approvals not found');
          }
      },

      
      async reject(approvalId, comment){
          const requestOptions = {
              method: "POST",
              headers: { "Content-Type": "application/json", 'Authorization': 'Bearer '+this.token },
              body: JSON.stringify({ 
                  approvalId,
                  comment
              })
          };
          const res = await fetch(process.env.VUE_APP_URL+'/approvals/reject', requestOptions)
          console.log("Rejection Response", res)
          let data = {};
          try { data = await res.json(); } catch(e) { console.error('Failed to parse reject response', e); }
          console.log("Response Data", data)
          if(data.status == true){
            toast.success(data.message || 'Approval request Rejected');
            if (this.isBDSelected) await this.fetchBusinessApprovals(); else await this.fetchApprovals();
          }else{
            toast.error(data.message || 'Approvals not found');
          }
      },

      async rejectApproval (approvalId) {
        this.closeApprovalModal()
        Swal.fire({
            title: "Rejection Comment (Optional)",
            input: "text",
            inputAttributes: {
              autocapitalize: "off"
            },
            showCancelButton: true,
            confirmButtonText: "OK",
            showLoaderOnConfirm: true,
            preConfirm: async (comment) => {
              await this.reject(approvalId, comment)
            },       
        }) 
      },

      getApprovalOrderNumber(approval) {
        if (!approval) return '—';
        const m = (approval.module || '').toString().toLowerCase();
        if (m === 'purchase') return approval.purchase?.purchaseNo || '—';
        if (m === 'pickup') return approval.pickupNote?.pickupNo || '—';
        if (m === 'dispatch' || m === 'dispatchnote') return approval.dispatchNote?.dispatchNo || '—';
        if (['purchase_request', 'purchase-request', 'purchaserequest'].includes(m)) {
          const pr = approval.purchaseRequest || approval.request || {};
          return pr.purchaseRequestNo || pr.requestNumber || ('PR#' + (pr.id || approval.purchaseRequestId || approval.moduleId || '')) || '—';
        }
        if (['businessopportunity', 'bidopportunity'].includes(m)) {
          const opp = approval.opportunity || {};
          return opp.title || opp.tenderTitle || opp.referenceNumber || ('#' + (opp.id || '')) || '—';
        }
        return '—';
      },

      getApprovalDenominator(approval) {
        try {
          const purchase = approval.purchase || {};
          const net = getPurchaseNetAmountExclusive(purchase);
          return net < CEO_NET_AMOUNT_THRESHOLD ? 3 : 4;
        } catch (e) {
          return 4;
        }
      },
      isQuotedItemInPO(submission, col) {
        try {
          const items = submission && submission.quotedItems ? submission.quotedItems : [];
          const it = items.find(li => (li.name || '').toString().trim() === col);
          return !!(it && it.includedInPO);
        } catch (e) { return false; }
      },
    },

    async mounted(){
      try {
        this.loading = true;
        if (this.isBDSelected) {
          await this.fetchBusinessApprovals();
        } else {
          await this.fetchApprovals();
        }
        await this.fetchProcessedApprovals();
        await this.fetchApprovalCounts();
      } catch (e) {
        console.error('Failed to fetch approvals on mount', e);
      } finally {
        this.loading = false;
        this.dataFetched = true;
      }
      this.scheduleReinitDataTable();

      // register bridge for buttons rendered via v-html
      try {
        if (typeof window !== 'undefined') {
          window.__openQuotationSummary = this.openQuotationSummary ? this.openQuotationSummary.bind(this) : null;
          window.__openComparePRPO = this.openComparePRPO ? this.openComparePRPO.bind(this) : null;
          window.__openPRAttachments = this.openPRAttachments ? this.openPRAttachments.bind(this) : null;
        }
      } catch (e) {
        console.warn('Failed to register __openQuotationSummary', e);
      }
    },
    beforeUnmount() {
      this.destroyDataTable()
      try { if (typeof window !== 'undefined' && window.__openQuotationSummary) delete window.__openQuotationSummary; if (typeof window !== 'undefined' && window.__openComparePRPO) delete window.__openComparePRPO; if (typeof window !== 'undefined' && window.__openPRAttachments) delete window.__openPRAttachments; } catch (e) { console.warn('Failed to cleanup __openQuotationSummary', e); }
    },
  }
  </script>

  <style scoped>
  .purchases-list{
    padding: 20px;
    margin-top: 30px;
    box-shadow: rgba(49, 32, 104, 0.2) 0 2px 8px 0;
  }
  .approvals-data-table-wrapper {
    margin-top: 11px;
  }
  .approvals-data-table-wrapper :deep(.dataTables_wrapper) {
    font-size: 11px;
  }
  
  @keyframes shimmer {
    0% { background-position: -468px 0 }
    100% { background-position: 468px 0 }
  }
  
  .skeleton-shimmer {
    display: inline-block;
    background: #f6f7f8;
    background-image: linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%);
    background-repeat: no-repeat;
    background-size: 800px 104px;
    animation: shimmer 1s linear infinite forwards;
    border-radius: 4px;
  }

  /* Color classes for summary cards */
  .primary { color: #007bff !important; }
  .info { color: #17a2b8 !important; }
  .warning { color: #ffc107 !important; }
  .danger { color: #dc3545 !important; }
  .secondary { color: #6c757d !important; }
  </style>